import http from "infra/http";
import { useMutation } from "react-query";

export function useVisualizarNotificacao() {
  return useMutation(
    `/v1/notificacao/visualizar`,
    (id: string) => {
      return http.put<{ id: string }>(`/v1/notificacao/${id}/visualizar`);
    },
    { retry: false }
  );
}
